import { Button } from "@/components/ui/button";
import { useAppDispatch } from "@/store/useApp";
import { XIcon } from "lucide-react";

interface ReferencesPanelProps {
  children: React.ReactNode;
  title?: string;
  description: React.ReactNode;
  onClose?: () => void;
  headerContent?: React.ReactNode;
}

const PanelLayout = ({
  children,
  title = "References",
  description,
  onClose,
  headerContent,
}: ReferencesPanelProps) => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      dispatch({ type: "SHOW_REFERENCE_PANEL", payload: { visible: false } });
    }
  };

  return (
    <aside className="fixed top-0 right-0 w-[400px] h-screen bg-white border-l border-gray-200 shadow-lg z-50">
      <div className="h-[calc(100vh-40px)] overflow-y-auto px-6 py-4">
        <div className="flex justify-between items-start gap-3 mb-4">
          <div className="min-w-0">
            <h3 className="text-lg font-semibold">{title}</h3>
            <span className="text-sm text-gray-500">{description}</span>
          </div>
          <div className="flex items-center gap-2">
            {headerContent}
            <Button
              variant="ghost"
              size="icon"
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-600 -mt-2 -mr-2"
            >
              <XIcon className="h-4 w-4" />
              <span className="sr-only">Close panel</span>
            </Button>
          </div>
        </div>

        {children}
      </div>
    </aside>
  );
};

export default PanelLayout;
